import type {
  Ticket,
  TicketCreateInput,
  TicketPriority,
  TicketStatus,
  TimeEntry,
  Uuid,
} from '@beacon/core';

import type { BeaconClient } from '../client.js';

export interface TicketListResponse {
  tickets: Ticket[];
}

export interface TicketTimeEntriesResponse {
  entries: TimeEntry[];
}

export interface CreateTimeEntryInput {
  hours: number;
  spentDate: string;
  notes: string;
}

export const ticketsApi = {
  list(client: BeaconClient): Promise<TicketListResponse> {
    return client.get<TicketListResponse>('/api/tickets');
  },

  create(client: BeaconClient, input: TicketCreateInput): Promise<Ticket> {
    return client.post<Ticket>('/api/tickets', input);
  },

  get(client: BeaconClient, number: string): Promise<Ticket> {
    return client.get<Ticket>(`/api/tickets/${number}`);
  },

  listTimeEntries(
    client: BeaconClient,
    number: string
  ): Promise<TicketTimeEntriesResponse> {
    return client.get<TicketTimeEntriesResponse>(
      `/api/tickets/${encodeURIComponent(number)}/time-entries`
    );
  },

  createTimeEntry(
    client: BeaconClient,
    number: string,
    input: CreateTimeEntryInput
  ): Promise<TimeEntry> {
    return client.post<TimeEntry>(
      `/api/tickets/${encodeURIComponent(number)}/time-entries`,
      input
    );
  },

  updateStatus(
    client: BeaconClient,
    number: string,
    status: TicketStatus
  ): Promise<Ticket> {
    return client.patch<Ticket>(`/api/tickets/${number}/status`, { status });
  },

  updatePriority(
    client: BeaconClient,
    number: string,
    priority: TicketPriority
  ): Promise<Ticket> {
    return client.patch<Ticket>(`/api/tickets/${number}/priority`, {
      priority,
    });
  },

  assign(
    client: BeaconClient,
    number: string,
    assigneeUserId: Uuid | null
  ): Promise<Ticket> {
    return client.patch<Ticket>(`/api/tickets/${number}/assign`, {
      assigneeUserId,
    });
  },
};
